import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { formatSalesOrderDate, type SalesOrderLine } from "@/mocks/search-sales-orders";

interface RowDetailDrawerProps {
  line: SalesOrderLine | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function RowDetailDrawer({ line, open, onOpenChange }: RowDetailDrawerProps) {
  if (!line) return null;

  const fields: Array<[string, string]> = [
    ["Description", line.itemDescription],
    ["Available", String(line.available)],
    ["Ship Complete", line.shipComplete ? "Yes" : "No"],
    ["ATP Lead Time", `${line.atpLeadTimeDays} days`],
    ["Commit", String(line.commit)],
    ["Price Level", line.priceLevel],
    ["Sub Total", `$${line.lineAmount.toFixed(2)}`],
    ["Customer ID", line.customerId],
    ["Line ID", line.lineId],
    ["Quantity Back Ordered", String(line.quantityBackOrdered)],
    ["Internal ID", line.internalId],
    ["Expected Ship Date", formatSalesOrderDate(line.expectedShipDate)],
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="inset-y-0 left-auto right-0 top-0 h-full w-full max-w-md translate-x-0 translate-y-0 gap-0 overflow-y-auto rounded-none border-l data-[state=open]:slide-in-from-right data-[state=closed]:slide-out-to-right">
        <DialogHeader>
          <DialogTitle>
            {line.orderNo} · {line.itemCode}
          </DialogTitle>
          <DialogDescription>{line.itemDescription}</DialogDescription>
        </DialogHeader>
        <dl className="mt-4 divide-y divide-border">
          {fields.map(([label, value]) => (
            <div key={label} className="flex items-center justify-between gap-3 py-2 text-sm">
              <dt className="text-muted-foreground">{label}</dt>
              <dd className="text-right font-medium">{value}</dd>
            </div>
          ))}
        </dl>
      </DialogContent>
    </Dialog>
  );
}
